module.exports = __webpack_public_path__ + "img/icon-regioni.50694976.png";